import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

import { doGetAllDrivers, doCreateDriver, doUpdateDriver, doDeleteDriver } from "./thunk";

const driversAdapter = createEntityAdapter({
  selectId: item => item._id,
  sortComparer: (a, b) => b.createdAt.localeCompare(a.createdAt),
});

const driverSlice = createSlice({
  name: "driver",
  initialState: {
    isFetching: false,
    status: "idle",
    metadata: {},
    entities: [],
    ids: [],
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(doGetAllDrivers.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doGetAllDrivers.fulfilled, (state, action) => {
      const { drivers, meta } = action.payload;
      state.isFetching = false;
      state.status = "succeeded";
      state.metadata = meta;
      driversAdapter.setAll(state, drivers);
    });
    builder.addCase(doGetAllDrivers.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });
    builder.addCase(doCreateDriver.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doCreateDriver.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
      driversAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doCreateDriver.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });
    builder.addCase(doUpdateDriver.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doUpdateDriver.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
      driversAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doUpdateDriver.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });
    builder.addCase(doDeleteDriver.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doDeleteDriver.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
      state.message = action.payload.message;
      driversAdapter.removeOne(state, action.meta.arg);
    });
    builder.addCase(doDeleteDriver.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });
  },
});

export const {
  selectAll: selectAllDrivers,
  selectById: selectDriverById,
  selectIds: selectDriverIds,
} = driversAdapter.getSelectors(state => state.driver);

const { reducer: driverReducer } = driverSlice;
export default driverReducer;
